import { useState } from "react";
import {
  Input,
  Button,
  FormField,
  SpaceBetween,
  Form,
  Container,
  ColumnLayout,
} from "@cloudscape-design/components-themed";
import { isLengthValid, isHalfNumberValid } from "../../utils/inputValidation";
import { getMessage } from "../..//features//error/messages";
import { LABELS } from "./constants";
import { useAppDispatch } from "../../app/hook";
import { createSearchCondition } from "../../features/slices/holdings-search";
import { COMMON_LABELS } from "../default-constants";

/* 
ホールディングス案件の検索条件
 */
const SearchBar = () => {
  // エラーメッセージ関連
  const [corporateNumberErrorMsg, setCorporateNumberErrorMsg] = useState("");
  const [companyNameErrorMsg, setCompanyNameErrorMsg] = useState("");

  // 法人番号
  const [corporateNumber, setCorporateNumber] = useState("");

  // 事業者名
  const [companyName, setCompanyName] = useState("");

  const dispatch = useAppDispatch();

  // 法人番号のチェック
  const handleCorporateNumberOnChange = (corporateNumber: string) => {
    // 数値チェック
    if (!isHalfNumberValid(corporateNumber)) {
      setCorporateNumberErrorMsg(
        getMessage("KGRERR006", LABELS.HOLDINGS_CORPORATE_NUMBER).label
      );

      return false;

      // 桁数チェック
    } else if (!isLengthValid(corporateNumber, 13)) {
      setCorporateNumberErrorMsg(getMessage("KGRERR059", 13).label);

      return false;
    }

    // ここまで来たら問題ないのでエラーを消す
    setCorporateNumberErrorMsg("");

    return true;
  };

  // 事業者名のチェック
  const handleCompanyNameOnChange = (companyName: string) => {
    // 文字数チェック
    if (!isLengthValid(companyName, 30)) {
      setCompanyNameErrorMsg(getMessage("KGRERR058", 30).label);

      return false;
    }

    // ここまで来たら問題ないのでエラーを消す
    setCompanyNameErrorMsg("");

    return true;
  };

  // 入力チェック
  const validateInputs = () => {
    if (!handleCorporateNumberOnChange(corporateNumber)) {
      return false;
    }

    if (!handleCompanyNameOnChange(companyName)) {
      return false;
    }

    return true;
  };

  // 検索ボタン押下時処理
  const handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // バリデーションチェック
    const result = validateInputs();

    if (result) {
      dispatch(
        createSearchCondition({
          corporateNumber: corporateNumber,
          name: companyName,
          timestamp: new Date().getTime(),
        })
      );
    }
  };

  return (
    <form onSubmit={handleOnSubmit}>
      <Form
        actions={
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="normal">{COMMON_LABELS.BTNS.SEARCH}</Button>
          </SpaceBetween>
        }
      >
        <Container>
          <SpaceBetween direction="vertical" size="l">
            <SpaceBetween direction="horizontal" size="xs">
              <FormField
                label={LABELS.HOLDINGS_CORPORATE_NUMBER}
                errorText={corporateNumberErrorMsg}
                constraintText="半角数字13桁以内"
              >
                <Input
                  value={corporateNumber}
                  onChange={(e) => {
                    setCorporateNumber(e.detail.value);
                    handleCorporateNumberOnChange(e.detail.value);
                  }}
                />
              </FormField>
            </SpaceBetween>
            <ColumnLayout columns={4}>
              <FormField
                label={LABELS.HOLDINGS_COMPANY_NAME}
                errorText={companyNameErrorMsg}
                constraintText="30文字以内"
              >
                <Input
                  value={companyName}
                  onChange={(e) => {
                    setCompanyName(e.detail.value);
                    handleCompanyNameOnChange(e.detail.value);
                  }}
                />
              </FormField>
            </ColumnLayout>
          </SpaceBetween>
        </Container>
      </Form>
    </form>
  );
};

export default SearchBar;
